import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BROWSER_COOKIES } from '@finder/shared/constants/app.constants';
import { Observable } from 'rxjs';

@Injectable()
export class SsrTokensInterceptor implements HttpInterceptor {
    private browserCookies = inject(BROWSER_COOKIES, { optional: true });

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Only SSR will have this token
        if (!this.browserCookies) {
            return next.handle(req);
        }

        // make sure the cookies are sent along
        req = req.clone({
            setHeaders: {
                'X-Disney-Browser-Cookies': JSON.stringify(this.browserCookies, null, 0),
            },
            withCredentials: true
        });

        return next.handle(req);
    }
}
